<template>
  <div class="submit-counter-delete">
    <el-dialog title="柜面删单详情页" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="formCheck" label-width="90px" size="small" label-position="top" :inline="false">
        <el-form-item label="状态" prop="">
          <el-input v-model="form.statusShow" placeholder="" style="width:320px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分提单号" prop="houseBillNo">
          <div v-for="(item,index) in noList" :key="index" class="bill-box">
            <el-input v-model="form.houseBillNo" placeholder="请输入分提单号" style="width:320px" :disabled="true"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="删单费" prop="fee">
          <el-input v-model="form.fee" placeholder="请输入删单费" style="width:320px" class="delete-fee" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="">
          <el-input v-model="form.remark" placeholder="最多输入30个字符" style="width:672px" maxlength="30" show-word-limit :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="附件" prop="masterBillNo" style="margin:0">
          <div class="file-list">
            <div class="file-name" v-for="(item,index) in form.appendixes" :key="index" @click="openUrl(item)">{{ item.name }}</div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="submit-btn" @click="closeDialog">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SubmitCounterDelete",
  props: {
    visible: Boolean,
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form:{},
      formCheck:{
        masterBillNo:[
          { required: true, message: '请输入分提单号', trigger: ['blur', 'change'] },
        ]
      },
      noList:[{
        value:''
      }]
    }
  },
  created () {
    this.form = this.detailData
    if(this.form.remark) {
      this.form.remark = this.getRemark(this.form.remark)
    }
  },
  methods: {
    getRemark(row){
      return row ? decodeURIComponent(atob(row)) : ''
    },
    openUrl(item){
      window.open(item.url, '_self')
    },
    // 关闭
    closeDialog () {
      this.$emit("closeDialog")
    }
  }
}
</script>

<style scoped lang="less">
.submit-counter-delete {
  color: #333333;
  font-size: 14px;
  .file-name:hover {
    color: #1170eb;
    cursor: pointer;
  }
  .el-link {
    vertical-align: top;
  }
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-form .el-form-item {
    margin: 0 16px 16px 0;
  }
  .delete-fee {
    position: relative;
    /deep/.el-input__inner {
      padding-right: 40px;
    }
  }
  .delete-fee:after {
    content: 'U币';
    display: block;
    position: absolute;
    right: 16px;
    top: 0;
  }
  .w-upload {
    margin-top: 8px;
    width: 672px;
  }
  .bill-box {
    margin-top: 14px;
    .iconfont {
      margin-left: 24px;
      cursor: pointer;
    }
    .icon-zengjiatidanhao {
      color: #1170eb;
    }
    .icon-shanchutidanhao {
      color: #ff1212;
    }
  }
  .bill-box:first-child {
    margin-top: 0;
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #333333;
  }
}
</style>